module.exports = __webpack_public_path__ + "media/metronic/_theme/media/envato/screen1-34dbd8a858a57ab44d6389b01f027335.jpg";